import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.socket, action) => {
  switch (action.type) {
    case ActionTypes.SOCKET_CONNECTED: {
      const { socket } = action;
      return {
        ...state,
        socketActive: true,
        socketActiveV2: true,
        socket,
      };
    }
    case ActionTypes.SOCKET_DISCONNECTED: {
      return {
        ...state,
        socketActiveV2: false,
      };
    }
    case ActionTypes.INITIATE_WEBSOCKET_CONNECTION:
      return {
        ...state,
        canWebsocketConnectionInitiated: true,
      };
    case `${ActionTypes.SOCKET_FETCH_SETTINGS}_SUCCESS`: {
      return {
        ...state,
        isSocketFetchedSettings: true,
      };
    }
    case ActionTypes.INITIALIZING_SOCKET: {
      const { connid, wid, sockid } = action;
      return {
        ...state,
        connid,
        wid,
        sockid,
      };
    }
    case `${ActionTypes.SET_FINGERPRINT}_SUCCESS`:
      return { ...state, fingerPrint: action.fingerPrint };
    case ActionTypes.TRACK_WINDOW_FOCUS: {
      let focusCount = state.trackVisibilityFocus;
      if (!focusCount) focusCount = 0;
      focusCount += 1;
      return { ...state, trackVisibilityFocus: focusCount };
    }
    case ActionTypes.TRACK_WINDOW_BLUR: {
      let blurCount = state.trackVisibilityBlur;
      if (!blurCount) blurCount = 0;
      blurCount += 1;
      return { ...state, trackVisibilityBlur: blurCount };
    }
    case ActionTypes.CAPTURE_SCREEN_EVENT: {
      let captureCount = state.captureScreenEvent;
      if (!captureCount) captureCount = 0;
      captureCount += 1;
      return { ...state, captureScreenEvent: captureCount };
    }
    case ActionTypes.TRACK_ROUTE_CHANGE:
      return { ...state, routeChange: action.data };
    case ActionTypes.SHOW_MULTI_SESSION_PROMPT:
      return { ...state, showMultiSession: true };
    case ActionTypes.MONITOR_SESSION:
      return { ...state, initSessionMonitorData: action.data };
    case ActionTypes.FAILED_SOCKET_EVENTS_STATUS: {
      const { status } = action.payload;
      return {
        ...state,
        failedSocketEventsStatus: status,
      };
    }
    case `${ActionTypes.GET_ACTIVE_SESSION}_SUCCESS`: {
      return {
        ...state,
        isSessionActive: false,
        sessionId: action.value,
      };
    }
    case `${ActionTypes.SET_ACTIVE_SESSION}_SUCCESS`: {
      return {
        ...state,
        isSessionActive: true,
        sessionId: action.value,
      };
    }
    case `${ActionTypes.CREATE_ACTIVE_SESSION}_SUCCESS`: {
      return {
        ...state,
        isSessionCreated: action.value,
      };
    }
    case ActionTypes.DISCONNECT_SOCKET: {
      return {
        ...state,
        shouldDisconnect: true,
      };
    }
    default:
      return state;
  }
};
